/**
 * DESIGN-PREVIEW MOCK DATA — TR homepage redesign.
 * The isolated preview database is empty, so "Güncel yazılar" renders these
 * representative public titles. Replace with the real post feed
 * (getHomePosts → Post contract) during integration.
 */
export type ThemeKey = "planet" | "tech" | "economy" | "meaning";

export type HomeTheme = {
  key: ThemeKey;
  no: string;
  title: [string, string];
  question: string;
  slug: string;
};

export const HOME_THEMES: HomeTheme[] = [
  { key: "planet", no: "01", title: ["İnsan ve", "Gezegen"], question: "Dünyayı değiştirmeye çalışırken, onunla birlikte yaşamayı unuttuk mu?", slug: "insan-ve-gezegen" },
  { key: "tech", no: "02", title: ["Teknoloji", "ve Güç"], question: "Yapabildiklerimiz arttıkça, neyi yapmamamız gerektiğine nasıl karar vereceğiz?", slug: "teknoloji-ve-guc" },
  { key: "economy", no: "03", title: ["Ekonomi", "ve Toplum"], question: "Ekonomiyi şekillendirirken, ekonomi bizi nasıl şekillendiriyor?", slug: "ekonomi-ve-toplum" },
  { key: "meaning", no: "04", title: ["İnsan ve", "Anlam"], question: "Nasıl yaşadığımızı belirleyen sistemlerin içinde, nasıl yaşamak istediğimize kim karar veriyor?", slug: "insan-ve-anlam" },
];

